export default "https://assets.pclncdn.com/web/next-landing/35c697f/_next/static/images/denver-bb3d7c9210d5f9eedce7f9a8378d229e.webp";